import React from 'react';
// formik
import { FieldArray } from 'formik';
//mui
import { Box } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import SalesForm from './SalesForm';

const SalesBillFormList = ({ formik, ArrayHelperRef, issueNo }) => {
  const useStyles = makeStyles({
    table: {
      '& .MuiTableCell-root': {
        border: '1px solid rgba(224, 224, 224, 1)',
        align: 'center',
      },
    },
  });

  const classes = useStyles();

  return (
    <FieldArray
      name="purchaseBills"
      render={(arrayHelpers) => {
        ArrayHelperRef.current = arrayHelpers;
        return (
          <Box>
            <TableContainer
              size="small"
              className={classes.table}
              sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
            >
              <Table padding="none">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">회차</TableCell>
                    <TableCell align="center">매출일자<br/>(작성 일자)</TableCell>
                    <TableCell align="center">매출처</TableCell>
                    <TableCell align="center">매출내용</TableCell>
                    <TableCell align="center">해외</TableCell>
                    <TableCell align="center">총매출금액</TableCell>
                    <TableCell align="center">기매출금액</TableCell>
                    <TableCell align="center">매출금액</TableCell>
                    <TableCell align="center">부가세</TableCell>
                    <TableCell align="center">매출합계</TableCell>
                    <TableCell align="center">수금예정일자</TableCell>
                    <TableCell align="center">매출횟수</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formik.values?.purchaseBills &&
                    formik.values?.purchaseBills.map((bill, index) => {
                      return (
                        <SalesForm
                          key={index}
                          index={index}
                          bill={bill}
                          formik={formik}
                          issueNo={issueNo}
                        />
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        );
      }}
    ></FieldArray>
  );
};

export default SalesBillFormList;
